const START_NUMBER = [
  '010',
  '011',
  '016',
  '017',
  '018',
  '019',
  '051',
  '053',
  '032',
  '062',
  '042',
  '052',
  '044',
  '031',
  '033',
  '043',
  '041',
  '063',
  '061',
  '054',
  '055',
  '064',
]
//2-3-4 or 3-4-4
export const phoneFormat = (phoneNumber: string) => {
  if (!phoneNumber) return
  if (phoneNumber.startsWith('02')) {
    return phoneNumber.replace(/^(\d{2})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
  } else if (START_NUMBER.includes(phoneNumber?.slice(0, 3))) {
    return phoneNumber.replace(/^(\d{3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
  } else if (phoneNumber?.length === 8) {
    return phoneNumber.replace(/^(\d{4})(\d{4})$/, `$1-$2`)
  } else {
    return phoneNumber.replace(/^(\d{4})(\d{4})$/, `$1-$2`)
  }
}

//6-7
export const corporateNumberFormat = (corporateNumber: string) => {
  if (!corporateNumber) return
  const value = corporateNumber.replace(/[^0-9]/g, '')
  return [value.slice(0, 6), value.slice(6)].join('-')
}

//3-2-5
export const corporateRegistrationNumberFormat = (corporateRegistrationNumber: string) => {
  if (!corporateRegistrationNumber) return
  const value = corporateRegistrationNumber.replace(/[^0-9]/g, '')
  return [value.slice(0, 3), value.slice(3, 5), value.slice(5)].join('-')
}

export const checkCardType = (cardNumber: string) => {
  const amex = ['34', , '37']
  const diners = ['36', '38', '39', '300', '301', '302', '303', '304', '305', '3095']
  if (amex.includes(cardNumber.slice(0, 2))) {
    return 15
  } else if (diners.includes(cardNumber.slice(0, 2))) {
    return 14
  } else if (diners.includes(cardNumber.slice(0, 3))) {
    return 14
  } else if (diners.includes(cardNumber.slice(0, 4))) {
    return 14
  } else return 16
}

export const cardFormat = (type: number, number: string) => {
  if (type === 15) {
    return [number.slice(0, 4), number.slice(4, 10), number.slice(10, 15)].join('-')
  } else if (type === 14) {
    return [number.slice(0, 4), number.slice(4, 10), number.slice(10, 14)].join('-')
  } else {
    return [number.slice(0, 4), number.slice(4, 8), number.slice(8, 12), number.slice(11, 16)].join('-')
  }
}

export const membershipCardFormat = (cardNumber: string) => {
  if (!cardNumber) return

  return [cardNumber.slice(0, 4), cardNumber.slice(4, 8), cardNumber.slice(8, 12), cardNumber.slice(12, 16)].join('-')
}
